import React, { useContext, useCallback } from "react";
import TextField from "component/textField/TextField";
import MaintenanceTaskPersonnelAssignmentExternalStaffContext from "module/maintenanceTaskPersonnelAssignment/externalStaff/context/MaintenanceTaskPersonnelAssignmentExternalStaffContext";
import MaintenanceTaskPersonnelAssignmentExternalStaffChangeContext from "module/maintenanceTaskPersonnelAssignment/externalStaff/change/MaintenanceTaskPersonnelAssignmentExternalStaffChangeContext";
import MaintenanceTaskPersonnelAssignmentExternalStaffFieldMetaDataContext from "module/maintenanceTaskPersonnelAssignment/externalStaff/validation/fieldMetaData/MaintenanceTaskPersonnelAssignmentExternalStaffFieldMetaDataContext";
import { MaintenanceTaskPersonnelAssignmentExternalStaffInterface } from "module/maintenanceTaskPersonnelAssignment/externalStaff/types";
import { MAINTENANCE_TASK_PERSONNEL_ASSIGNMENT_EXTERNAL_STAFF_NAME_FIELD_NAME } from "module/maintenanceTaskPersonnelAssignment/externalStaff/constants";
import XLabelField from "component/labelField/XLabelField";
import { getFieldMetaDataWithErrorHandling } from "module/fieldMetaData/getFieldMetaData";

const MaintenanceTaskPersonnelAssignmentExternalStaffNameFieldContainer: React.FC =
  () => {
    const { entity } = useContext(
      MaintenanceTaskPersonnelAssignmentExternalStaffContext
    );
    const { change: changeHelper } = useContext(
      MaintenanceTaskPersonnelAssignmentExternalStaffChangeContext
    );
    const { getFieldMetaData } = useContext(
      MaintenanceTaskPersonnelAssignmentExternalStaffFieldMetaDataContext
    );

    const maintenanceTaskPersonnelAssignment =
      entity as MaintenanceTaskPersonnelAssignmentExternalStaffInterface;

    const { warnings, errors, isEditable } = getFieldMetaDataWithErrorHandling(
      () =>
        getFieldMetaData(
          MAINTENANCE_TASK_PERSONNEL_ASSIGNMENT_EXTERNAL_STAFF_NAME_FIELD_NAME
        )
    );

    const change = useCallback(
      (name?: string) => {
        changeHelper({ name });
      },
      [changeHelper]
    );

    const value = maintenanceTaskPersonnelAssignment.name;

    if (isEditable) {
      return (
        <TextField
          {...{
            value,
            change,
            errors,
          }}
        />
      );
    }

    return <XLabelField {...{ label: value, warnings, errors }} />;
  };

export default React.memo(
  MaintenanceTaskPersonnelAssignmentExternalStaffNameFieldContainer
);
